var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownChevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00007 12.4887L3.83716 7.32583L5.16298 6L9.00007 9.83709L12.8372 6L14.163 7.32583L9.00007 12.4887Z",
    fill: "black",
    fillOpacity: 0.76
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevIcon);
export default __webpack_public_path__ + "static/media/down-chev-icon.94c8c41792ab4de1bfd8533d20a45715.svg";
export { ForwardRef as ReactComponent };